import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';
import { XmlCursor } from '../cursor/xmlCursor.class';
import { XMLCursorPositions } from '../cursor/xmlCursorPos.class';

export class XmlDomCleaner {
  public static cleanUp(node: Node, actualCursor: XmlCursor) {
    this.concatTextNodes(node, actualCursor);
  }

  /***
   * if two textnodes are direct siblings: concat to one textnode
   */
  public static concatTextNodes(node: Node, actualCursor: XmlCursor, nodeDepth = 0): void {
    let restart = true;

    while (restart === true) {
      restart = false;

      for (let i = 0; i < node.childNodes.length; ++i) {
        const firstToCheck = node.childNodes[i];
        if (DomDummyNodeManager.IsDummyNode(firstToCheck)) {
          throw new Error('Dummynodes have to be removed before using XmlDomCleaner!');
        }
        if (firstToCheck.nodeType === Node.TEXT_NODE) {
          const secondToCheck = firstToCheck.nextSibling;
          if (secondToCheck !== null && secondToCheck.nodeType === Node.TEXT_NODE) {
            // two text nodes after each other => concat
            if (actualCursor.StartPos.ActualNode === secondToCheck) {
              actualCursor.StartPos.SetCursor(firstToCheck, XMLCursorPositions.CursorInsideTextNode, firstToCheck.textContent.length + actualCursor.StartPos.PosInTextnode);
            }
            if (actualCursor.EndPos.ActualNode === secondToCheck) {
              actualCursor.EndPos.SetCursor(firstToCheck, XMLCursorPositions.CursorInsideTextNode, firstToCheck.textContent.length + actualCursor.EndPos.PosInTextnode);
            }
            firstToCheck.textContent = firstToCheck.textContent + secondToCheck.textContent;
            node.removeChild(secondToCheck);
            restart = true;
          }
        }
      }
    }

    // update child nodes
    for (let i = 0; i < node.childNodes.length; ++i) {
      this.concatTextNodes(node.childNodes[i], actualCursor, nodeDepth + 1);
    }
  }
}
